import styles from './style.postcss';
import { testClass } from 'omni-common-ui';
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export const IdpStatus = {
  PROOFREADING: 'proofreading',
  SENT_TO_DOS: 'senttodos',
  PUBLISHED: 'published',
  INCOMPLETE: 'incomplete',
  COMPLETED: 'completed',
  READY: 'ready',
  REJECTED: 'rejected',
};
const STATUS_PROOFREADING = IdpStatus.PROOFREADING;
const STATUS_SENT_TO_DOS = IdpStatus.SENT_TO_DOS;
const STATUS_PUBLISHED = IdpStatus.PUBLISHED;
const STATUS_COMPLETED = IdpStatus.COMPLETED;
const STATUS_INCOMPLETE = IdpStatus.INCOMPLETE;
const STATUS_READY = IdpStatus.READY;
const STATUS_REJECTED = IdpStatus.REJECTED;

const IndividualDevelopmentPlanStatus = (props) => {
  const { status, className } = props;

  const lowercaseStatus = status.toLowerCase();

  const containerClasses = classnames(styles.IndividualDevelopmentPlanStatus, className);
  const statusClasses = classnames(styles.IndividualDevelopmentPlanStatus_inner, {
    [styles.__sent]: lowercaseStatus === STATUS_SENT_TO_DOS ||
      lowercaseStatus === STATUS_PROOFREADING,
    [styles.__published]: lowercaseStatus === STATUS_PUBLISHED ||
        lowercaseStatus === STATUS_COMPLETED,
    [styles.__missing]: lowercaseStatus === STATUS_INCOMPLETE,
    [styles.__ready]: lowercaseStatus === STATUS_READY,
    [styles.__rejected]: lowercaseStatus === STATUS_REJECTED,
  }, testClass('status'));

  let statusToDisplay;
  switch (lowercaseStatus) {
    case STATUS_SENT_TO_DOS:
      statusToDisplay = 'Sent to DoS';
      break;
    default:
      statusToDisplay = status;
  }

  return <div className={containerClasses}>
    <div className={statusClasses}>{statusToDisplay}</div>
  </div>;
};

IndividualDevelopmentPlanStatus.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string,
};

export default IndividualDevelopmentPlanStatus;



// WEBPACK FOOTER //
// ./components/IndividualDevelopmentPlanStatus/index.jsx